import { LocalStorageKey } from "./storageKeys";

export const getFromLocalStorage = <T>(
  key: LocalStorageKey,
  defaultValue: T
): T => {
  if (typeof window !== "undefined") {
    const itemFromStorage = global?.window?.localStorage.getItem(key);
    let item = null;
    try {
      if (itemFromStorage) {
        item = JSON.parse(itemFromStorage);
      }
    } catch {
      item = itemFromStorage;
    }
    return item ? item : defaultValue;
  } else {
    return defaultValue;
  }
};

export const saveToLocalStorage = <T>(key: LocalStorageKey, item: T) => {
  if (item) {
    const serializedItem = JSON.stringify(item);
    global?.window?.localStorage.setItem(key, serializedItem);
    global?.window?.dispatchEvent(
      new StorageEvent("storage", {
        key,
        newValue: serializedItem,
      })
    );
  }
};

export const removeFromLocalStorage = (key: LocalStorageKey) => {
  global?.window?.localStorage.removeItem(key);
  global?.window?.dispatchEvent(
    new StorageEvent("storage", {
      key,
      newValue: null,
    })
  );
};
